<template>
  <el-container class="up-main">
      <el-aside width="211px">
          <left-menu :active="7"></left-menu>
      </el-aside>
      <el-main class="u-main">
        <!-- <el-steps class="steps" :active="active" align-center>
					<el-step title="主体材料"></el-step> 
					<el-step title="产品文本"></el-step> 
					<el-step title="标的信息录入"></el-step>
				</el-steps> -->
        <!-- 主体 -->
				<div v-show="active == 1">
					<step1 :id="id" :active="active" @next="next"/>
				</div>

				<!-- 产品 -->
				<div v-show="active == 2">
					<step2 :active="active" @next="next" @prev="prev"/>
				</div>

				<!-- 3 -->
				<div v-show="active == 3">
					<step3 :active="active" @next="next" @prev="prev"/>
				</div>

        <!-- 4 -->
				<div v-show="active == 4">
					<step4 :active="active" @next="next" @prev="prev"/>
				</div>

        <!-- 5 -->
				<div v-show="active == 5">
					<step5 :active="active" @prev="prev"/>
				</div>
        
      </el-main>
  </el-container>
</template>

<script>
import leftMenu from '../contract/components/leftMenu'
import step1 from './components/step1'
import step2 from './components/step2'
import step3 from './components/step3'
import step4 from './components/step4'
import step5 from './components/step5'
export default {
  name: "addConsumption",
  components: {
    leftMenu, step1, step2, step3, step4, step5
  },
  data() {
    return {
      active: 1,
      sceneType: this.$route.query.sceneType,
      id: ''
    }
  },
  created() {
    this.id = this.$route.query.id || '';
    this.getInBlacklist()
  },
  methods: {
    prev() {
      this.active--;
    },
    next(){
      this.active++;
    },
    getInBlacklist(){
      let checkParams = {
        platform: 4,
        projectName: sessionStorage.projectName,
        socialCode: sessionStorage.socialCode
      }
      // 判断黑名单
      this.$api.api.checkInBlacklist(checkParams).then(res => {
        if(res.content.checkResult){
          this.$alert('黑名单企业禁入，如有疑问联系数据方处理', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.push({path: `/consumption`});
            }
          });
        }       
      });
    },
  }
}
</script>

<style lang="less">
@import '../style.less';
.el-message {
  top: 400px !important;
  z-index: 9999 !important;
}
</style>
